'use strict';

const getStoredLanguage = state => {
  return state.language;
};

export default {
  getStoredLanguage
};
